//This is the user's cart

const UserCartComponent = () => {
  return (
    <div>
      <h3>This is the User's cart!</h3>
    </div>
  );
};

export default UserCartComponent;
